/* 🤖 this file was generated by svg-to-ts */
export const matIconRawOff: {
  name: 'raw-off';
  data: string;
} = {
  name: 'raw-off',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m17.15 14.32.59-2.36.76 3.04h1.48l1.5-6h-1.5l-.74 3-.74-3h-1.52l-.74 3-.74-3H14l.72 2.9zM1.39 4.22 6.17 9H3v6h1.5v-2h1.1l.9 2H8l-.9-2.1c.5-.3.9-.8.9-1.4v-.67l1.43 1.43L8.75 15h1.5l.38-1.5h.04l9.11 9.11 1.41-1.41L2.81 2.81 1.39 4.22zM6.5 11.5h-2v-1h2v1z"/></svg>`
};
